<ng-template #displayText let-crumb="crumb">
  @if (crumb.translationInfo) {
    @if (crumb.replacementObj) {
      {{ crumb.translationInfo.defaultText | translate : crumb.translationInfo.token : crumb.translationInfo.scope | template : crumb.replacementObj : true }}
    } @else {
      {{ crumb.translationInfo.defaultText | translate : crumb.translationInfo.token : crumb.translationInfo.scope }}
    }
  } @else if (crumb.label) {
    {{ crumb.label }}
  }
</ng-template>

@for (crumb of this.breadcrumbs(); track crumb){
  @if (!$first) {
    <span class="divider mat-body-small" [class.last]="$last">/</span>
  }
  @if ($last) {
    <span class="last mat-body-small">
						<ng-container
              [ngTemplateOutlet]="displayText"
              [ngTemplateOutletContext]="{crumb: crumb}"/>
				</span>
  } @else {
    <a [routerLink]="getUrl($index)" class="mat-body-small">
      <ng-container
        [ngTemplateOutlet]="displayText"
        [ngTemplateOutletContext]="{crumb: crumb}"/>
    </a>
  }
}
